(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popup-size-chart"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() {
      $(document).on("click", ".sc-btn", function() {
        if (!$(this).hasClass("active")) {
          $('body').addClass("sc-active")
          $(".sc-btn").removeClass("active")
          $(this).addClass("active")
          let unit = $(this).attr("data-value")

          $(".sc-tbl .sc-value-num").each(function() {
            let datanum = $(this).text().trim()
            let newdatanum = 0;
            if (unit == "CM") {
              datanum = datanum.replace("cm", "")
              newdatanum = parseFloat(datanum) * 2.54;
              $(this).text(newdatanum.toFixed(1) + "cm")
            } else {
              datanum = datanum.replace("in", "")
              newdatanum = parseFloat(datanum) / 2.54;
              $(this).text(newdatanum.toFixed(1) + "inch")
            }

          })
        }
      })
  })
  } catch(e) { console.error(e); }
})();

})();
